import _stripTags from "./stripTags.js";
const stripTags = _stripTags;
export default (function getLineCount(text) {
  return text.split("</p>").filter(textLine => {
    return stripTags(textLine).trim() !== "";
  }).length;
});